export default function Contact() {
    return (
        <section id="contact" className="card contact">
            <div className="contact__text">
                <h2 className="card__title">Kontakt aufnehmen</h2>
                <p className="card__text">
                    Lust auf einen Austausch über Cloud, Plattformen oder ein gemeinsames Projekt?
                    Schreib mir gerne eine Mail — ich melde mich zeitnah zurück.
                </p>
            </div>
            <a className="btn btn--primary contact__cta" href="mailto:alex@efremidis.de">
                alex@efremidis.de
            </a>
        </section>
    );
}
